export const ACCOUNT_REQUEST = 'ACCOUNT_REQUEST'
export const ACCOUNT_SUCCESS = 'ACCOUNT_SUCCESS'
export const ACCOUNT_ERROR = 'ACCOUNT_ERROR'
